module.exports = new __parcel__URL__("shop_machines_lightning_tower.d9b52033.png").toString();